import { SURF_PLUGIN_ID } from "../model/surfDeck.js";
import { surfGraphQLFetch } from "../graphql/httpClient.js";
import { SURF_GRAPHQL } from "../graphql/queries.js";
import { COLD_SYNC_SINCE } from "../sync/types.js";
import { newId } from "../model/surfDeck.js";
export const SURF_LAYOUT_TEMPLATE_DOC_TYPE = "surf.layout.template";
export const SURF_LAYOUT_TEMPLATE_SCHEMA_VERSION = 1;
export function layoutTemplateToPayloadJSON(title, slots, layoutId) {
    const payload = {
        schemaVersion: SURF_LAYOUT_TEMPLATE_SCHEMA_VERSION,
        layoutId,
        title,
        slots,
    };
    return JSON.stringify(payload);
}
export function parseLayoutTemplatePayload(raw) {
    try {
        const obj = JSON.parse(raw);
        if (!Array.isArray(obj.slots) || !obj.slots.length)
            return null;
        return obj;
    }
    catch {
        return null;
    }
}
function rowToTemplate(row) {
    if (row.docType !== SURF_LAYOUT_TEMPLATE_DOC_TYPE || row.pluginId !== SURF_PLUGIN_ID)
        return null;
    if (row.deleted)
        return null;
    const payload = parseLayoutTemplatePayload(row.payloadJSON);
    if (!payload)
        return null;
    return {
        documentId: row.documentId,
        title: row.title,
        layoutId: payload.layoutId,
        slots: payload.slots,
        version: row.version ?? undefined,
        updatedAt: row.updatedAt,
    };
}
export async function listSurfLayoutTemplates(cfg) {
    const idToken = await cfg.getIdToken();
    const results = [];
    let nextToken;
    let pages = 0;
    do {
        pages += 1;
        const page = await surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.deltaSync,
            variables: { input: { lastSyncAt: COLD_SYNC_SINCE, nextToken } },
            resultKey: "deltaSync",
        });
        for (const row of page.pluginDocuments ?? []) {
            const rec = rowToTemplate(row);
            if (rec)
                results.push(rec);
        }
        nextToken = page.nextToken ?? undefined;
    } while (nextToken && pages < 8);
    return results.sort((a, b) => (b.updatedAt ?? "").localeCompare(a.updatedAt ?? ""));
}
export async function saveSurfLayoutTemplate(cfg, title, slots, layoutId, documentId, expectedVersion) {
    const idToken = await cfg.getIdToken();
    const payloadJSON = layoutTemplateToPayloadJSON(title, slots, layoutId);
    const trimmedTitle = title.trim() || "Layout";
    if (documentId) {
        const row = await surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.updatePluginDocument,
            variables: {
                documentId,
                input: {
                    title: trimmedTitle,
                    state: "active",
                    docSchemaVersion: SURF_LAYOUT_TEMPLATE_SCHEMA_VERSION,
                    payloadJSON,
                    expectedVersion: expectedVersion ?? undefined,
                },
            },
            resultKey: "updatePluginDocument",
        });
        const rec = rowToTemplate(row);
        if (!rec)
            throw new Error("Risposta update layout non valida.");
        return rec;
    }
    const id = newId();
    const row = await surfGraphQLFetch({
        endpoint: cfg.endpoint,
        idToken,
        query: SURF_GRAPHQL.putPluginDocument,
        variables: {
            input: {
                documentId: id,
                pluginId: SURF_PLUGIN_ID,
                docType: SURF_LAYOUT_TEMPLATE_DOC_TYPE,
                docSchemaVersion: SURF_LAYOUT_TEMPLATE_SCHEMA_VERSION,
                title: trimmedTitle,
                state: "active",
                payloadJSON,
            },
        },
        resultKey: "putPluginDocument",
    });
    const rec = rowToTemplate(row);
    if (!rec)
        throw new Error("Risposta put layout non valida.");
    return rec;
}
export async function deleteSurfLayoutTemplate(cfg, documentId) {
    const idToken = await cfg.getIdToken();
    await surfGraphQLFetch({
        endpoint: cfg.endpoint,
        idToken,
        query: SURF_GRAPHQL.deletePluginDocument,
        variables: { documentId },
        resultKey: "deletePluginDocument",
    });
}
export function layersFromCustomLayoutSlots(slots, contents) {
    return slots.map((slot, index) => {
        const isImage = slot.role === "image";
        return {
            id: newId(),
            type: isImage ? "image" : "text",
            x: slot.rect.x,
            y: slot.rect.y,
            w: slot.rect.w,
            h: slot.rect.h,
            z: index + 1,
            rotation: 0,
            content: contents[slot.role] ?? (isImage ? "Immagine" : ""),
            textRole: slot.textRole,
            style: { slotRole: slot.role },
        };
    });
}
